import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/transportistas/transportistas';
import TransportistasList from './Transportistas';

const ms2p = (state) => {
  return {
    ...state.transportistas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(TransportistasList);
